<!-- Main starts -->
<div role="main" class="container">
    <!-- Header starts -->
    <nav class="navbar navbar-expand-lg navbar-light bg-light">
        <img src="assets/images/openid_logo.svg" alt="Logo OpenID">
    </nav>
    <!-- Header ends -->
    <div class="card">
        <h5 class="card-header">OpenID Login</h5>
        <div class="card-body">
            <h5 class="card-title">Benvenuto {{loggedUser.nome}} {{loggedUser.cognome}} </h5>
            <p class="card-text">Di seguito l'elenco dei claim recuperati dal token JWT</p>
            <table class="table table-striped">
                <thead>
                  <tr>
                    <th scope="col">
                        <strong>Nome claim</strong>
                    </th>
                    <th scope="col">
                        <strong>Valore claim</strong>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let elemento of loggedUserInfo">
                    <td>{{elemento.nomeClaim}}</td>
                    <td>{{elemento.valoreClaim}}</td>
                  </tr>
                </tbody>
              </table>
            <p class="card-text">
                Cliccando sul pulsante <b>Logout</b> inizierai il processo di logout autenticazione con il modulo di
                <b>Authentication Manager</b>
            </p>
            <p class="caed-text">
                <a href="#" class="btn btn-primary" (click)="logout()">Logout</a>
            </p>
        </div>
    </div>
</div>